/** Shared palette and routing constants for the WHOOP workspace port. */

/** The design's color tokens (the `C` object in the source mockup). */
export const C = {
  accent: '#b59bff',
  good: '#7fd1a3',
  warn: '#e3c673',
  low: '#e0897a',
  text: '#E8E6E1',
  text2: '#97958d',
  text3: '#6a6862',
  grid: 'rgba(255,255,255,0.08)',
  bg: '#0c0c0e',
  panel: '#141416',
  panelAccent: '#16141b',
} as const;

export const WHOOP_PAGES = [
  'now',
  'plan',
  'progress',
  'builder',
  'trends',
  'experiments',
  'settings',
] as const;

export type WhoopPage = (typeof WHOOP_PAGES)[number];

/** Narrow an arbitrary route segment to a known WHOOP page, falling back to `now`. */
export function coerceWhoopPage(value: string | undefined): WhoopPage {
  return WHOOP_PAGES.find((page) => page === value) ?? 'now';
}
